<template>
  <v-container fluid class="payroll-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/payroll/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindPayroll=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-2" @click="makePaymentList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Pay
              </v-btn>
              <v-btn to="/paystatement/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Statements
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="data_selected"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="payrolls-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="header_items"
              :items="data_payroll"
              :items-per-page="itemPerPage"
              >
              <template v-slot:top>
                <v-dialog
                  v-model="isDeletePayroll"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Payroll?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_payroll.payrollname  }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeletePayroll = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deletePayroll(delete_payroll)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.payrollnum="{ item }">
                <p class="two-line">{{item.payrolltype}} {{ item.payrollnum  }}</p>
                <p v-if="item.payrolldate!=undefined" class="two-line">{{ new Date(item.payrolldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                <p class="two-line">{{item.payrollname}}</p>
              </template>
              <template v-slot:item.payments="{ item }">
                <div v-if="item.payments" style="font-size: 10pt;">{{ item.payments.map(item=>new Date(item.transdate).toLocaleString("en-SG", { year: '2-digit', month: '2-digit', day: 'numeric' }) + ':&nbsp;&nbsp;' + `$${item.transamount.toFixed(2)}`).join('\n') }}</div>
              </template>
              <template v-slot:item.payrollstartdate="{ item }">
                <p class='two-line'>{{ new Date(item.payrollstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }} -</p>
                <p class='two-line'>{{ new Date(item.payrollenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
              </template>
              <template v-slot:item.isData="{ item }">
                {{ item.isData}}
              </template>
              <template v-slot:item.approvalidnum="{ item }">
                <div v-if="item.approvalidnum!=null">
                  <p class="two-line" style="margin-left: 5px;">
                    <v-avatar v-if="item.approvalimage!=null && item.approvalimage!=''" size="40">
                      <img v-bind:src="item.approvalimage" alt="">
                    </v-avatar>
                  </p>
                <p class="two-line"><span style="margin-left:5px">{{ item.approvalname }} </span></p>
                </div>
              </template>
              <template v-slot:item.payrolltotal="{ item }">
                <p class="two-line"><span style="font-size: x-small;">{{ item.primaryCurrency }}</span> {{ item.payrolltotal.toFixed(2).toLocaleString('en-SG') }}</p>
                <p v-if="item.primaryCurrency!=item.secondaryCurrency" class="two-line"><span style="font-size: x-small;">{{ item.secondaryCurrency }}</span> {{ (item.payrolltotal * item.currencyRate).toFixed(2).toLocaleString('en-SG') }}</p>
              </template>
              <template v-slot:item.payrollstatus="{ item }">
                <v-chip :color="getStatusColor(item.payrollstatus)" small>
                  {{ item.payrollstatus }}
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.payrollstatus=='New'" icon color="primary" @click="updatePayrollPendingDialog(item)">
                    <v-icon>mdi-account-edit-outline</v-icon>
                </v-btn>
                <v-btn v-if="['New', 'Pending', 'Processing'].indexOf(item.payrollstatus)!=-1" icon color="primary" @click="updatePayrollSendDialog(item)">
                  <v-icon>mdi-text-box-edit</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.payrollstatus=='New'" icon color="primary" @click="DeleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                <download-excel
                  v-if="item.isData=='Yes'"
                  class="btn btn-default"
                  :data="item.data"
                  worksheet="My Worksheet"
                  type="xls"
                  :name="getFileName()"
                >
                  <v-btn 
                    v-show="item.data.length>0"
                    icon 
                    color="primary"
                  >
                  <v-icon>mdi-microsoft-excel</v-icon>
                  </v-btn>
                </download-excel>

              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindPayroll"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Payroll</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="['New', 'Pending', 'Partial', 'Completed']"
                    v-model="find_query.payrollstatus"
                    label="Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="Payroll Num"
                    v-model="find_query.payrollnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Payroll Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.startdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="find_query.startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                         @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_startdate.save(find_query.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindPayroll = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetFind"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findPayroll"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog
        v-model="isApproveSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send for Approval</span>
            </v-card-title>
            <v-card-text>
              {{ approve_send.payrollname }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="approve_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isApproveSend=false; approve_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="approve_send.confirm!=='Send'"
                @click="updatePayrollPending"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isPayrollSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send Payroll</span>
            </v-card-title>
            <v-card-text>
              {{ payroll_send.payrollname }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="payroll_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isPayrollSend=false; payroll_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="payroll_send.confirm!=='Send'"
                @click="updatePayrollSend"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '../../../util/tools';

export default {
  name: 'payrollList',
  data() {
    return {
      data_payroll: [],
      data_selected: [],
      isDeletePayroll: false,
      isFindPayroll: false,
      isApproveSend: false,
      isPayrollSend: false,
      emailDialog: false,
      menu_startdate: null,
      menu_enddate: null,
      find_query: {},
      delete_payroll: {},
      email_payroll: {},
      approve_send: {}, 
      payroll_send: {},
      header_items: [
        { text: 'Payroll', value: 'payrollnum' },
        { text: 'Period Start-End', value: 'payrollstartdate', width:'12%' },
        { text: 'Amount', value: 'payrolltotal', width: "10%" },
        { text: 'Paid', value: 'payments', width: "12%" },
        { text: 'Approval', value: 'approvalidnum', width: '12%' },
        { text: 'Status', value: 'payrollstatus', width:'10%'  },
        { text: 'Actions', value: 'actions', sortable: false, width:'10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      isLoading: false,
      getStatusColor: getStatusColor,
    }
  },

  computed: {
    ...mapState('Payroll', ['payrolls', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating', 'currentEmployeeId']),
    ...mapState('Employee', ['employees']),
    ...mapState('Account', ['accounts']),
  },
  methods: {
    ...mapActions('Payroll', ["getPayrollsRequest", "findPayrollsRequest", "deletePayrollRequest", "updatePayrollPendingRequest", "updatePayrollSendRequest"]),
    ...mapActions('PayStatement', ['getPayStatementsByPayroll']),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('Account', ["getAccountsRequest"]),
    checkError(){
      if(this.data_selected.length==0) return false;
      if(this.data_selected.find(item=>item.payrollstatus=='Completed')!=null) return false;
      return true;
    },
    makePaymentList(){
      if(!this.checkError()) {
        if(this.data_selected.length==0) this.dialogMessage='No Payroll selected';
        else this.dialogMessage='The following Payroll cannot be deposited:  ' + this.checkBills();
        this.dialogAlert=true; 
        return;
      }
      let bills = Object.assign([], this.data_selected);
      let json = {bills: bills, isPayrolls: true};
      json['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'BatchPaymentAdd', params: json });
    },
    editItem(item) {
      this.$router.push({ name: 'PayrollEdit', params: item })
    },
    getFileName(){
      var d = new Date();
      var name = 'payroll-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    async getPayStatements(id){
      let statements = await this.getPayStatementsByPayroll(id);
      let results = [];
      let fields = [];
      for(var x in statements) {
        let statement = statements[x];
        let employee = this.employees.find(employee=>employee._id==statement.employeeid);
        results.push({
          employeeid: employee['_id'], 
          employee_name: employee['employeename'], 
          pay_date: new Date(statement.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }),
        });
        let filter = statement.transactions.filter(x=>x.transsubtype=='Addition')
        for(var a in filter){
          let trans = filter[a];
          let result = results.find(x=>x.employeeid==trans.employeeid);
          let name = trans['transdesc'];
          let currency = trans['transcurrency'];
          let currency2 = trans['transcurrency2'];
          let field1 = name + ` (${currency})`
          let field2 = name + ` (${currency2})`
          if(!(fields.includes(field1))) fields.push({name: field1, rank: 1});
          if(!(fields.includes(field2))) fields.push({name: field2, rank: 1});

          if(field1 in result) result[field1] = result[field1] + parseFloat(trans.transcredit);
          else result[field1] = parseFloat(trans.transcredit); 

          if(field2 in result) result[field2] = result[field2] + parseFloat(trans.transcredit2);
          else result[field2] = parseFloat(trans.transcredit2);
        }
        filter = statement.transactions.filter(x=>x.transsubtype=='Deduction')
        for(var b in filter){
          let trans = filter[b];
          let result = results.find(x=>x.employeeid==trans.employeeid);
          let name = trans['transdesc'];
          let currency = trans['transcurrency'];
          let currency2 = trans['transcurrency2'];
          let field1 = name + ` (${currency})`
          let field2 = name + ` (${currency2})`
          if(!(fields.includes(field1))) fields.push({name: field1, rank: 2});
          if(!(fields.includes(field2))) fields.push({name: field2, rank: 2});
          if(field1 in result) result[field1] = result[field1] + parseFloat(trans.transdebit);
          else result[field1] = parseFloat(trans.transdebit); 

          if(field2 in result) result[field2] = result[field2] + parseFloat(trans.transdebit2);
          else result[field2] = parseFloat(trans.transdebit2); 
        }
        
        filter = statement.transactions.filter(x=>x.transsubtype=='Contribution')
        for(var c in filter){
          let trans = filter[c];
          let result = results.find(x=>x.employeeid==trans.employeeid);
          let name = trans['transdesc'];
          let currency = trans['transcurrency'];
          let currency2 = trans['transcurrency2'];
          let field1 = name + ` (${currency})`
          let field2 = name + ` (${currency2})`
          if(!(fields.includes(field1))) fields.push({name: field1, rank: 3});
          if(!(fields.includes(field2))) fields.push({name: field2, rank: 3});
          if(field1 in result) result[field1] = result[field1] + parseFloat(trans.transcredit);
          else result[field1] = parseFloat(trans.transcredit); 

          if(field2 in result) result[field2] = result[field2] + parseFloat(trans.transcredit2);
          else result[field2] = parseFloat(trans.transcredit2);
        }
      }
      for(var result of results){
        for(var field of fields) {
          if(!( field in result )) result[field] = null;
        }
      }

      console.log(fields);
      return results;      
    },
    async getJson(){
      console.log(this.data_selected)
      let json = {
        ordernum: this.data_selected, 
      };
      return [json];
    },
    async deletePayroll(item) {
      let result = await this.deletePayrollRequest(item);
      let index = this.data_payroll.findIndex(i=>i._id==result._id);
      this.data_payroll.splice(index, 1);
      this.isDeletePayroll = false;
    },
    async findPayroll(){
      this.isFindPayroll = false;
      if(Object.keys(this.find_query).length==0){
        let result = await this.getPayrollsRequest();
        this.data_payroll = Object.assign([], result);
      }
      else{
        let result = await this.findPayrollsRequest(this.find_query);
        this.data_payroll = Object.assign([], result);
      }
    },
    async resetFind(){
      this.find_query = {};

    },
    printItem(item) {
      this.$router.push({ name: 'PayrollPrint', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'PayrollView', params: item })
    },
    DeleteDialog(item) {
      this.isDeletePayroll = true;
      this.delete_payroll = {
        _id: item._id,
        payrollname: item.payrollname,      
      }
    },
    updatePayrollPendingDialog(item) {
      this.isApproveSend = true;
      this.approve_send = { _id: item._id, payrollnum: item.payrollnum, payrollname: item.payrollname };
    },
    updatePayrollSendDialog(item) {
      this.isPayrollSend = true;
      this.payroll_send = { _id: item._id, payrollnum: item.payrollnum, payrollname: item.payrollname };
    },
    async updatePayrollPending() {
      this.isApproveSend = false;
      let result = await this.updatePayrollPendingRequest(this.approve_send);
      console.log(result)
      //let index = this.data_payments.findIndex((x) => x._id == result._id);
      //this.data_payments.splice(index, 1, result);
      this.approve_send = {};
    },
    async updatePayrollSend() {
      this.isPayrollSend = false;
      let result = await this.updatePayrollSendRequest(this.payroll_send);
      let index = this.data_payroll.findIndex((x) => x._id == result._id);
      this.data_payroll.splice(index, 1, result);
      this.payroll_send = {};
    },
  },
  async created() {
    if(this.payrolls.length==0) await this.getPayrollsRequest();
    this.data_payroll = Object.assign([], this.payrolls);
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
